import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Typography, InputLabel } from "@material-ui/core";
import { setStudentCategories } from "../firebaseApi";
const DEVMODE = true;
const styles = (theme) => ({});

function InstructorScreenshotDialogs(props) {
    
	return (
		<>
            <Dialog fullWidth maxWidth="sm" 
                open={props.openNoDeviceDialog} 
                onClose={() => {
                    props.openNoDeviceDialogCtl(false);
                }}
            >
                <DialogTitle>
                    <Typography style={{ fontSize: "1.3rem" }} color="primary">
                        No Screenshot Device Selected
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Screenshots are enabled, but no screenshot device has been selected. Please be aware that 
                        no screenshots will be taken until a device is selected.
                    </Typography>
                </DialogContent>
                <DialogActions
                    style={{justifyContent: "center"}}
                >
                    <Button 
                        color="primary" 
                        onClick={() => {
                            props.openNoDeviceDialogCtl(false);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth maxWidth="sm" 
                open={props.openNoAccessDialog} 
                onClose={() => {
                    props.openNoAccessDialogCtl(false);
                }}
            >
                <DialogTitle>
                    <Typography style={{ fontSize: "1.3rem" }} color="primary">
                        Failed to Access Google Drive Folder
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Screenshots are enabled, but we could not access the Google Drive folder for storing screenshots. 
                        Please be aware that screenshots will not be taken or displayed until access is granted. 
                    </Typography>
                </DialogContent>
                <DialogActions
                    style={{justifyContent: "center"}}
                >
                    <Button 
                        color="primary" 
                        onClick={() => {
                            props.openNoAccessDialogCtl(false);
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
		</>
	);
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(InstructorScreenshotDialogs))));
